<template>
  <div class="border">
    <list
      title_add="Создать кредит"
      title_add_key="create_credit"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="false"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </div>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  props: ["id"],
  created() {
    this.itemLink += `/${this.id}/loans`;
    this.setLink += `/${this.id}/loans`;
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "field",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "bank",
          label: "Выберите банк",
          type: "select",
          modal: "bank",

          selectKey: "name",
        },
        {
          col: " col-12 col-md-6",
          key: "loan_amount_desired",
          label: "Сумма кредита",
          type: "field",
          price: true,
          textType: "number",
        },
        {
          col: " col-12 col-md-6",
          key: "loan_term_desired",
          label: "Срок кредита",
          type: "field",
          price: true,
          textType: "number",
        },
        {
          key: "loan_goal",
          label: "Цель кредита",
          type: "hidden",
          default: "Пополнение оборотных средств",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_loan",
      itemLink: "dealers",
      setLink: "dealers",
      columns: [
        {
          key: "id",
          title: "ID",
        },
        {
          key: "bank",
          object: "name",
          title: "Банк",
          disableLink: true,
        },
        {
          key: "loan_amount_desired",
          title: "Сумма кредита",
        },
        {
          key: "loan_term_desired",
          title: "Срок кредита",
        },
        {
          key: "created_at",
          dateTimeFormat: true,
          title: "Дата создания",
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
